//@flow

import React, {useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/styles';
// import OnboardingBanner from './components/OnboardingBanner';
import {useMissingRequiredSteps} from './utils';

/* import Step1Image from '../../assets/img/onboarding/config-1.webp';
import Step2Image from '../../assets/img/onboarding/config-2.webp';
import Step3ImageDesktop from '../../assets/img/onboarding/step-3-desktop.webp';
import Step3ImageMobile from '../../assets/img/onboarding/step-3-mobile.webp';
import Step4Image from '../../assets/img/onboarding/step-4.webp'; */

import StepImage from '../../assets/img/steps/step-by-step-iphone.webp';
import OnboardingItem from './components/OnboardingItem';
/* import OnboardingCard from './components/OnboardingCard';
import ToolList from './components/ToolList';
import OnboardingHelp from './components/OnboardingHelp'; */
// import miniInstagramIcon from '../../assets/img/miniInstagramIcon.png';

// import type {Props as OnboardingBannerProps} from './components/OnboardingBanner';
import type {Props as OnboardingItemProps} from './components/OnboardingItem';
import WelcomeModal from './components/WelcomeModal';
import {useShowWelcomeModal} from '../dashboard/utils';
import {Typography} from '@material-ui/core';
import {useStorefrontUrl, useStoreBusinessModel} from '../store/utils';
import CustomButton from '../../elements/CustomButton/CustomButton';
import {useUser} from '../auth/hooks';
import {TIENDADA_LINKS} from '../../constants/tiendada-links';
import SnackBar from '../../elements/SnackBar/SnackBar';
import CoverStep from './components/StepComponents/CoverStep';
import ProductStep from './components/StepComponents/ProductStep';
import SeeStoreStep from './components/StepComponents/SeeStoreStep';
import WhatsappStep from './components/StepComponents/WhatsappStep';

import type {StoreDevice} from '../../entities';
import {getDevicesService} from '../multichat/chat/promises';
import {useIsFeatureInTier} from '../../utils/component';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  otherConfig: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',

      flex: 1,
      alignItems: 'center',
    },
  },
  grid: {
    display: 'grid',
    gap: theme.spacing(2),

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },

    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '2fr 1fr',
    },
  },
  itemRequired: {
    [theme.breakpoints.up('lg')]: {
      gridRow: '1 / 3',
    },
  },
  itemTools: {
    [theme.breakpoints.up('sm')]: {
      gridColumn: '1 / 3',
    },

    [theme.breakpoints.up('lg')]: {
      gridColumn: '2 / 3',
    },
  },
  stepsContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    background: 'white',
    padding: '1rem',
    borderRadius: '1rem',
    width: '100%',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headText: {
    fontWeight: 600,
    fontSize: '1.25rem',
  },
  progressBadge: {
    display: 'flex',
    alignItems: 'center',
    padding: '.25rem .75rem',
    background: 'rgba(249,207,107, 0.25)',
    borderRadius: '1rem',
    fontSize: '.75rem',
  },
  stepList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.75rem',
  },
  footer: {
    fontSize: '1.125rem',
    fontWeight: 600,
    textAlign: 'center',
  },
  helpCard: {
    background: 'linear-gradient(89.92deg, #18003D -15.03%, #37127A 90.58%)',
    borderRadius: '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '1rem',

    [theme.breakpoints.up('md')]: {
      padding: '2rem',
    },
  },
  helpTitle: {
    fontWeight: 700,
    fontSize: '1.25rem',
    color: 'white',
    textAlign: 'center',
  },
  helpImage: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
      width: '80%',
      margin: '0 auto',
      height: 'auto',
    },
  },
  helpSubtitle: {
    fontWeight: 400,
    fontSize: '1rem',
    color: 'white',
    textAlign: 'center',
  },
  helpButton: {
    marginTop: '1rem',
    width: '100%',
    background: '#F7D144',
    color: '#18003D',
    borderRadius: '8px',
    fontWeight: 600,
    padding: '1rem',

    '&:hover': {
      background: '#f7d1449c',
      color: '#18003D',
    },
  },
}));

/* type MissingSteps = {
  deliveryRate: boolean,
  logo: boolean,
  paymentMethods: boolean,
  products: boolean,
}; */

/* const ONBOARDING_BANNER_DATA: OnboardingBannerProps[] = [
  {
    headline: '¡Mira como quedó esta tienda, la tuya también puede verse así!',
    tagline: 'Te ayudamos a completar tu tienda en simples pasos',
    background: 'linear-gradient(89.92deg, #18003D -15.03%, #37127A 90.58%)',
    image: Step1Image,
    id: 'CUSTOMIZE-STORE',
    btnFilled: {
      label: '¡Empieza ahora!',
      link: '/my-store/cover-customize?fromOnboarding=true',
    },
    btnOutlined: {
      label: 'Ver otras tiendas',
      link:
        'https://tiendadateam.notion.site/Directorio-TiendaDa-fbaa954a4a59426ab9f02ab78547c30f',
      isExternal: true,
    },
  },
  {
    headline: 'Sube tu primer producto en menos de 30 segundos',
    background: 'linear-gradient(189.55deg, #7B39FF -22.06%, #18003D 137.02%)',
    image: Step2Image,
    id: 'UPLOAD-PRODUCTS',
    btnFilled: {
      label: 'Subir Producto',
      link: '/products/new?fromOnboarding=true',
    },
    btnOutlined: {
      label: 'Subir desde Instagram',
      link: '/products?instagramUpload=true&fromOnboarding=true',
      icon: (
        <img style={{height: 24, width: 24}} src={miniInstagramIcon} alt="" />
      ),
    },
  },
  {
    headline:
      'Establece tus tarifas de delivery para poder enviar tus productos',
    background: ' linear-gradient(180deg, #124953 0%, #0A2D33 100%)',
    id: 'CONFIGURE-LOGISTICS',
    btnFilled: {
      label: 'Configurar tarifas',
      link: '/configure/logistics/shipping?fromOnboarding=true',
    },
    btnOutlined: {
      label: 'Más información',
      link: 'https://www.youtube.com/watch?v=zIWr2yBYeCs&t=1s',
      isExternal: true,
    },
    image: Step3ImageDesktop,
    mobileImage: Step3ImageMobile,
  },
  {
    headline: '¡Recibe tus pagos configurando tus métodos!',
    image: Step4Image,
    background: 'linear-gradient(173.05deg, #54D18C -31.24%, #349568 111.63%)',
    id: 'CONFIGURE-PAYMENT-METHODS',
    btnFilled: {
      label: 'Configurar Métodos de Pago',
      link: '/configure/payment-methods?fromOnboarding=true',
    },
    btnOutlined: {
      label: 'Más información',
      link: 'https://www.youtube.com/watch?v=k4uJWFYZfFg&t=17s',
      isExternal: true,
    },
  },
]; */

/* const getBannerData = ({
  deliveryRate,
  logo,
  paymentMethods,
  products,
}: MissingSteps) => {
  if (!logo) {
    return ONBOARDING_BANNER_DATA[0];
  }

  if (!products) {
    return ONBOARDING_BANNER_DATA[1];
  }

  if (!deliveryRate) {
    return ONBOARDING_BANNER_DATA[2];
  }

  if (!paymentMethods) {
    return ONBOARDING_BANNER_DATA[3];
  }

  return ONBOARDING_BANNER_DATA[0];
};
 */
export default function OnboardingConfig() {
  const {
    logo,
    products,
    setPageDisplayed,
    pageDisplayed,
  } = useMissingRequiredSteps();

  const storeUrl = useStorefrontUrl();
  const storeBusinessModel = useStoreBusinessModel();
  const [storeDevices, setStoreDevices] = useState<StoreDevice[]>([]);

  const user = useUser();

  const [copyLink, setCopyLink] = useState(false);

  const classes = useStyles();

  const {showModal, handleClose} = useShowWelcomeModal();

  const hasWhatsappWebFeature = useIsFeatureInTier('TIENDACHAT_WHATSAPP_WEB');

  useEffect(() => {
    getDevicesService(['WHATSAPP_WEB'], {
      page: 0,
      size: 2,
    }).then(response => {
      setStoreDevices(response.data || []);
    });
  }, []);

  const REQUIRED_STEPS: OnboardingItemProps[] = [
    {
      label: 'URL de la tienda',
      description: storeUrl,
      active: true,
      isButton: true,
      to: '/configure/customize',
      id: 'STORE-URL',
      info: 'Este es el enlace que compartirás con tus clientes',
      onClick: () => {
        navigator.clipboard &&
          navigator.clipboard
            .writeText(storeUrl)
            .then(() => setCopyLink(true))
            .catch(() => setCopyLink(false))
            .finally(() => setTimeout(() => setCopyLink(false), 3000));
      },
    },
    {
      label: 'Agrega tu logo',
      description: 'Personaliza tu tienda',
      active: logo,
      isButton: !!logo,
      to: '/configure/customize',
      id: 'CUSTOMIZE-STORE',
      component: <CoverStep />,
    },
    {
      label:
        storeBusinessModel === 'PRODUCT'
          ? 'Sube tus productos'
          : 'Sube tus servicios',
      active: products,
      isButton: !!products,
      description:
        storeBusinessModel === 'PRODUCT'
          ? 'Agrega tus productos para empezar a vender'
          : 'Agrega tus servicios para empezar',
      to: '/products/new',
      id: 'UPLOAD-IG-PRODUCTS',
      disabledInfo: 'Agrega tu logo para poder subir productos',
      component: <ProductStep />,
    },
    {
      label: 'Conecta tu número de WhatsApp (opcional)',
      active: storeDevices.length > 0,
      isButton: storeDevices.length > 0,
      description: 'Conecta tu número de WhatsApp para recibir pedidos',
      to: '/chat/configuration/whatsapp',
      id: 'CONNECT-WHATSAPP',
      component: <WhatsappStep />,
      disabled: !hasWhatsappWebFeature,
    },
    {
      label: 'Explora tu tienda',
      description: 'Mira como va quedado tu tienda virtual',
      to: storeUrl,
      isButton: !!pageDisplayed,
      active: pageDisplayed,
      id: 'STORE-FRONT-URL',
      disabledInfo: 'Agrega productos para poder ver tu tienda',
      onClick: () => setPageDisplayed(true),
      component: <SeeStoreStep setPageDisplayed={setPageDisplayed} />,
    },
  ];

  const enabledRequiredSteps = REQUIRED_STEPS.filter(item => !item.disabled);

  const counter = enabledRequiredSteps.filter(item => item.active).length;
  const total = enabledRequiredSteps.length;

  return (
    <>
      <SnackBar
        mode="success"
        message={copyLink ? 'Enlace copiado al portapapeles' : ''}
      />
      <div className={classes.root}>
        {/* {isFreeTrialSubscription && <TimeLine />} */}

        <section className={classes.grid}>
          <div className={classes.stepsContent}>
            <header className={classes.header}>
              <Typography className={classes.headText}>
                ¡Hola {user && user.firstName}!
              </Typography>
              <span className={classes.progressBadge}>
                {counter}/{total}
              </span>
            </header>

            <Typography className={classes.subtitle}>
              Completa todos los pasos para configurar tu tienda y desbloquea el
              panel de ventas
            </Typography>

            <div className={classes.stepList}>
              {enabledRequiredSteps.map((item, index) => (
                <OnboardingItem {...item} required key={index} />
              ))}
            </div>
          </div>

          <div className={classes.helpCard}>
            <Typography className={classes.helpTitle}>
              ¿Necesitas ayuda?
            </Typography>

            <Typography className={classes.helpSubtitle}>
              Mira nuestro video tutorial
            </Typography>

            <img
              src={StepImage}
              className={classes.helpImage}
              alt="Iphone con una tienda de muebles hecha en tiendada"
            />

            <CustomButton
              className={classes.helpButton}
              href={TIENDADA_LINKS.customerSupport.consultancy}
              target="_blank"
              rel="noopener noreferrer"
            >
              Agenda una asesoría
            </CustomButton>
          </div>
        </section>
      </div>
      {showModal && <WelcomeModal onClose={() => handleClose()} />}
    </>
  );
}
